<section class="choose-documents-sign-popup">
  <div class="choose-documents-sign-popup__header">
    <div class="choose-documents-sign-popup__header-content">
      <p class="choose-documents-sign-popup__title">Firma documentos</p>
      <p class="choose-documents-sign-popup__subtitle">
        Selecciona los documentos que deseas firmar.
      </p>
    </div>
    <div class="choose-documents-sign-popup__header-close">
      <lib-icon icon="close" [isClickable]="true" (onClick)="onBack()"></lib-icon>
    </div>
  </div>

  <div class="choose-documents-sign-popup__options">
    <app-documents-sign-option (optionSelectedEvent)="handleOptionSelected($event)"
      (drawerOpenedEvent)="handleDrawerOpen()"
      [title]="option1Config.title"
      [description]="option1Config.description"
      [options]="option1Config.options"
      [isButtonDisabled]="isDrawerButtonDisabled"
    ></app-documents-sign-option>

    <app-documents-sign-option *ngIf="showDeclaracionJuradaIndicator"
      (optionSelectedEvent)="handleOptionSelected($event)"
      [title]="option2Config.title"
      [description]="option2Config.description"
      [isCompleted]="djSigned"
    ></app-documents-sign-option>
  </div>
</section>
